import React from 'react';
import { QualifioComponent } from '@src/interfaces';
import Qualifio from '@src/components/Qualifio';

const QualifioSection = ({ id, title, url, options }: QualifioComponent) => (
  <div
    className="qualifio"
    data-vr-zone={`Qualifio ${title ?? id}`}
  >
    <Qualifio options={options} title={title} url={url} />
  </div>
);

export default QualifioSection;


